module.exports = __webpack_public_path__ + "static/media/400078_02.a41fb653.png";